import { render } from "./Sobre.vue?vue&type=template&id=6f109b93&scoped=true"
import script from "./Sobre.vue?vue&type=script&lang=js"
export * from "./Sobre.vue?vue&type=script&lang=js"

import "./Sobre.vue?vue&type=style&index=0&id=6f109b93&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f109b93"]])

export default __exports__